/**
 * Environment Configuration
 *
 * Centralizes access to import.meta.env variables for easier testing.
 * Every VITE_*_API_URL read passes through the monolith-routing
 * shim in `./apiRouting.ts` so URLs baked from GitHub secrets get
 * rewritten to the new consolidated backend shape at load time.
 * The toggle itself lives in env (`VITE_USE_MONOLITH_ROUTING`);
 * see that file's header for context + revert path.
 */

import { readMonolithFlag, rewriteApiUrl } from './apiRouting';

const USE_MONOLITH = readMonolithFlag(import.meta.env);

export const ENV = {
  AUTH_API_URL: rewriteApiUrl(import.meta.env.VITE_AUTH_API_URL, USE_MONOLITH),
  STORAGE_API_URL:
    rewriteApiUrl(import.meta.env.VITE_STORAGE_API_URL, USE_MONOLITH) ||
    rewriteApiUrl('https://authentication.domainboost.io', USE_MONOLITH)!,
  USER_API_URL: rewriteApiUrl(import.meta.env.VITE_USER_API_URL, USE_MONOLITH),
  MASTER_API_URL: rewriteApiUrl(import.meta.env.VITE_MASTER_API_URL, USE_MONOLITH),
  WALLET_API_URL: rewriteApiUrl(import.meta.env.VITE_WALLET_API_URL, USE_MONOLITH),
  ORDER_API_URL: rewriteApiUrl(import.meta.env.VITE_ORDER_API_URL, USE_MONOLITH),
  SITE_API_URL: rewriteApiUrl(import.meta.env.VITE_SITE_API_URL, USE_MONOLITH),
  SUPPORT_API_URL: rewriteApiUrl(import.meta.env.VITE_SUPPORT_API_URL, USE_MONOLITH),
  NOTIFICATION_API_URL: rewriteApiUrl(import.meta.env.VITE_NOTIFICATION_API_URL, USE_MONOLITH),
  TASK_API_URL: rewriteApiUrl(import.meta.env.VITE_TASK_API_URL, USE_MONOLITH),
  APP_SOURCE: import.meta.env.VITE_APP_SOURCE || 'advertiser_app',
  WEBSITE_BASE_URL: import.meta.env.VITE_WEBSITE_BASE_URL || 'https://domainboost.io',
  // WordPress theme's db/v1 REST namespace — feeds Help Articles +
  // Webapp FAQs in the webapp. Defaults to the dev proxy target
  // (`/api/wp` → `http://localhost/domainboost_website` via
  // vite.config.ts) so local dev works without any .env override.
  WP_API_URL: import.meta.env.VITE_WP_API_URL || '/api/wp',
  AUTH_GUARD: import.meta.env.VITE_AUTH_GUARD === 'true',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,

  // Keycloak (used by SSO redirect; client_secret stays on the backend)
  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL || 'https://keycloak.domainboost.io',
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM || 'domainboost',
  KEYCLOAK_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || '',
} as const;
